import * as React from 'react'
import { Breadcrumbs } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { useMemo } from 'react'
import { getActiveBreadcrumb } from '../utilities'
import { STEPS } from './types'

interface StepBreadcrumbProps {
  step: STEPS
}

export const StepBreadcrumbs: React.FC<StepBreadcrumbProps> = ({ step }) => {
  const t = useT()
  const breadcrumbsContext = 'Breadcrumb text in service modal'
  const breadcrumbs = useMemo(
    () => [
      t('Customer', { context: breadcrumbsContext }),
      t("Customer's item", { context: breadcrumbsContext }),
      t('Work description', { context: breadcrumbsContext }),
      t('Schedule', { context: breadcrumbsContext }),
    ],
    [t, breadcrumbsContext]
  )

  const activeBreadcrumb = getActiveBreadcrumb({
    step,
    breadcrumbs,
  })

  return (
    <Breadcrumbs
      breadcrumbs={breadcrumbs}
      activeBreadcrumb={activeBreadcrumb}
    />
  )
}
